import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export const ROOM_THEME_MATCH = "match";
export const ROOM_THEME_LIGHT = "light";
export const ROOM_THEME_DARK = "dark";

export const ROOM_THEME_MODES = {
  [ROOM_THEME_MATCH]: "inherit",
  [ROOM_THEME_LIGHT]: "light-mode",
  [ROOM_THEME_DARK]: "dark-mode",
};

export default class RoomTheme extends BaseOption {
  static userInterfaceComponent = {
    label: "Room Theme",
    component: inspectorTools.SIMPLE_PICKER,
    displayOverrideIcon: false,
    descriptionMessage: "Match site follows your theme in light and dark mode; Light and Dark force one look.",
    props: {
      options: [
        { id: ROOM_THEME_MATCH, name: "Match site" },
        { id: ROOM_THEME_LIGHT, name: "Light" },
        { id: ROOM_THEME_DARK, name: "Dark" },
      ],
    },
  };

  static defaultValue = ROOM_THEME_MATCH;

  static convertConfigValueToCompiledValue(configValue) {
    return Object.keys(ROOM_THEME_MODES).includes(configValue) ? configValue : ROOM_THEME_MATCH;
  }
}
